/** @jsxImportSource @emotion/react */
import { Box, CircularProgress } from '@mui/material'
import { containerStyles } from './LoadingSpinner.style'

export const LoadingSpinner = () => {
  return (
    <Box css={containerStyles}>
      <CircularProgress size={48} color="primary" />
    </Box>
  )
}
